import { useEffect, useState } from "react";
import s3_Upload from "../customComponents/s3_Upload";
import { useSubmitPanAadharMutation } from "../../api/panAadharCheckAPI";
import { getToken } from "../../services/Token";
import UploadDocument from "../customComponents/customDocumentUpload";
import Loader from "../customComponents/customLoader";
import { toast } from "react-toastify";
const AadharPanDocumentUpload = ({closeDialoge}) => {
  const [submitPanAadhar, {isLoading, isSuccess, isError}] = useSubmitPanAadharMutation();
  const [panAadhar, setPanAadhar] = useState({
    aadharDocument: "",
    panDocument: "",
  });
  const [docLoader, setDocLoader] = useState({
    aadharDocument: false,
    panDocument: false,
  });
  const isPanAadharData = !panAadhar.aadharDocument || !panAadhar.panDocument
  const submitDocuments = () => {
    const payLoad = panAadhar
    payLoad.aadharDocument.name = "Aadhar Card"
    payLoad.panDocument.name = "Pan Card"
    const id = getToken("Id");
    submitPanAadhar({
      employeeId: id,
      body: panAadhar,
    });
  };

  const handleNewUpload = async (new_file) => {
    setDocLoader(prev => ({
        ...prev,
        [new_file.target.name]: true
      }));
    const data = await s3_Upload(new_file);
    setDocLoader(prev => ({
        ...prev,
        [new_file.target.name]: false
      }));
    setPanAadhar({
      ...panAadhar,
      [data.name]: data,
    });
  };
  useEffect(() => {
    if(isSuccess){
        closeDialoge(true)
    }
    if(isError){
        toast.error("Something went wrong")
    }
  }, [isSuccess, isError]);
  return (
    <>{isLoading && <Loader/>}
      <div className="bg-white p-4 rounded-lg">
        <UploadDocument
          name={"aadharDocument"}
          label={"Aadhar Document"}
          fileData={panAadhar.aadharDocument}
          handleDocUpload={handleNewUpload}
          docLoader= {docLoader.aadharDocument}
          isMandatory={true}
        />
        <UploadDocument
          name={"panDocument"}
          label={"Pan Document"}
          fileData={panAadhar.panDocument}
          handleDocUpload={handleNewUpload}
          docLoader= {docLoader.panDocument}
          isMandatory={true}
        />

        <div className="flex justify-center">
            <button
              id="SubmitDocuments"
              className={`m-5 ${
                isPanAadharData
                  ? "bg-gray-500 text-black cursor-not-allowed"
                  : "bg-blue-500 text-white cursor-pointer"
              }   font-bold p-4 rounded-full w-[12rem] text-xl mr-4`}
              onClick={submitDocuments}
              disabled={
                isPanAadharData
              }
            >
              Submit
            </button>
        </div>
      </div>
    </>
  );
};

export default AadharPanDocumentUpload;
